import { createStyle } from '@gluestack-style/react';

export const TabsTabPanel = createStyle({});
